import React from 'react';
import { useNavigate } from 'react-router-dom';
import Util from 'util/util';
import { LoggerService } from 'services/LoggerService';
import { Translation } from 'react-i18next';
import { TFunction } from 'i18next';

import './CardComponent.scss';

const logger = LoggerService.getLogger('AccountCardComponent');

interface Props {
  title: string;
  editRoute?: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

const CardComponent: React.FunctionComponent<Props> = ({
  children,
  title,
  editRoute,
  buttonText,
  onButtonClick,
}): JSX.Element => {
  const navigate = useNavigate();
  const hasButton = editRoute || onButtonClick;
  const buttonId = (onButtonClick ? 'action-' : 'edit-') + Util.removeSpaces(title);

  const handleButtonClick = (): void => {
    if (onButtonClick) {
      onButtonClick();
    } else if (editRoute) {
      navigate(editRoute);
    } else {
      logger.error('Missing required prop editRoute.');
    }
  };

  return (
    <Translation>
      {(t: TFunction): JSX.Element => {
        return (
          <div className="card mb-4 cardComponent">
            <div className="card-body py-3 px-3">
              <div className="container-fluid">
                <div className="row titleWrap">
                  <div className="col-12">
                    <h5 className="card-title text-uppercase mb-4">{title}</h5>
                    <div className="card-divider w-100 mb-3" />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">{children}</div>
                </div>
                {hasButton && (
                  <div className="row">
                    <div className="col-12">
                      <div className="col-4 px-0 float-right">
                        <button
                          id={buttonId}
                          className="btn btn-primary superRadius float-right pt-2 pb-2 m-auto text-uppercase"
                          onClick={handleButtonClick}
                        >
                          {buttonText ? buttonText : t('Update')}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      }}
    </Translation>
  );
};

export default CardComponent;
